<template>
    <form v-if="device === 'desktop'" @submit.prevent="enter" class="header__search">
        <input style="cursor: text;" class="header__search-input" v-model="query" type="text" placeholder="Поиск">
    </form>
    <form v-else class="header__search" @submit.prevent="enter">
        <input class="header__search-input" v-model="query" type="text" placeholder="Поиск">
        <button class="header__search-btn" type="submit"></button>
    </form>
</template>

<script>
export default {
    name : "HeaderSearch",
    props: ['device'],
    data()
    {
        return {
            query: ''
        }
    },
    methods: {
        enter()
        {
            let formData = new FormData();
            formData.append('query', this.query);
            fetch("/api/search_query/", {method: 'POST', body: formData}).
                then(response => response.json()).
                then(async resp =>
                     {
                         if(resp.success === true)
                         {
                             this.query    = resp.data['valid_query'];
                             location.href = '/search?q=' + this.query + '&s=Поиск';
                         }
                     });
        },
    }
}
</script>

<style scoped>

</style>